var map = {
	"./face1.png": 439,
	"./face2.png": 440,
	"./face3.png": 441
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 438;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/face.*\.png$
// module id = 438
// module chunks = 0